import React from 'react';

import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import legacyRunModal from 'ui-library/legacyRunModal';
import DeleteWorklistsModal from 'worklists/DeleteWorklistsModal';
import {RefreshOptions} from 'worklists/WorklistActions';

import {WorklistSummaryGraphQL} from '../../graphql-fragments/worklists/__generated/WorklistSummaryGraphQL';

export interface DeleteWorklistsButtonProps {
  className?: string;
  selectedWorklists: Array<WorklistSummaryGraphQL>;
  refreshOptions: RefreshOptions;
}

export default function DeleteWorklistsButton(props: DeleteWorklistsButtonProps): JSX.Element {
  const disabled = props.selectedWorklists.length === 0;
  const tooltipTitle = props.selectedWorklists.length === 0 ? 'Must select worklists' : 'Delete worklists';

  return (
    <Tooltip title={tooltipTitle}>
      <Button
        buttonStyle={ButtonStyle.TERTIARY_WHITE}
        className={props.className}
        disabled={disabled}
        icon="delete"
        onClick={() => {
          legacyRunModal(DeleteWorklistsModal, {
            worklists: props.selectedWorklists,
            refreshOptions: props.refreshOptions,
          });
        }}
        size={ButtonSize.SMALL}
      />
    </Tooltip>
  );
}
